"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLabels = exports.defaultDurationOptions = exports.defaultGoalOptions = exports.defaultLineChartOptions = void 0;
var defaultLineChartOptions = {
  chart: {
    zoomType: 'xy',
    styledMode: true
  },
  title: false,
  xAxis: {
    type: 'datetime'
  },
  yAxis: {
    title: {
      text: '',
      rotation: 0,
      offset: 15,
      align: 'high',
      y: -20
    }
  },
  plotOptions: {
    series: {
      threshold: -Infinity,
      marker: {
        enabled: false,
        symbol: 'circle',
        states: {
          hover: {
            radius: 3
          }
        }
      },
      states: {
        hover: {
          halo: {
            size: 7
          }
        }
      }
    },
    area: {
      name: ''
    }
  },
  legend: {
    useHTML: true,
    symbolHeight: 0,
    symbolWidth: 0,
    symbolRadius: 0
  },
  tooltip: {
    useHTML: true
  },
  credits: false
};
exports.defaultLineChartOptions = defaultLineChartOptions;
var defaultGoalOptions = {
  type: 'line',
  marker: {
    enabled: true,
    radius: 8,
    symbol: 'goal',
    states: {
      hover: {
        radius: 8
      }
    }
  },
  states: {
    hover: {
      halo: {
        size: 14
      }
    }
  },
  showInLegend: false,
  className: 'highcharts-goal'
};
exports.defaultGoalOptions = defaultGoalOptions;
var defaultDurationOptions = {
  type: 'line',
  marker: {
    enabled: true,
    radius: 4,
    symbol: 'circle',
    states: {
      hover: {
        enabled: false
      }
    }
  },
  showInLegend: false,
  className: 'highcharts-duration'
};
exports.defaultDurationOptions = defaultDurationOptions;
var defaultLabels = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};
exports.defaultLabels = defaultLabels;